import { createRequestInstance } from '../'

const ME_URL = import.meta.env.VITE_SSO_ME_URL || ''

const request = createRequestInstance({})

type FetchUserResponse = {
  userId: string
  firstName: string
  lastName: string
  email: string
  adddress?: string
  city?: string
}

export async function fetchUser() {
  const response = await request.get<FetchUserResponse>(ME_URL)
  const { data } = response
  const { userId, firstName, lastName, email } = data

  return {
    id: Number(userId),
    firstName,
    lastName,
    email,
  }
}
